/**
* Selector for post Submit shopping reducer
*
* This function create an selector
*
*/

export const resSubmitShopping = (state) => state.postSubmitShoppingReducer.data;
export const resGeneralSubmitShopping = (state) => state.postSubmitShoppingReducer;
